import { render, staticRenderFns } from "./PulseOx.vue?vue&type=template&id=673aac33&"
import script from "./PulseOx.vue?vue&type=script&lang=js&"
export * from "./PulseOx.vue?vue&type=script&lang=js&"
import style0 from "./PulseOx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports